import * as React from "react"
import type { SVGProps } from "react"
const SvgSignals = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.83 19.52q-.3.3-.73.3a1 1 0 0 1-.7-.32 10 10 0 0 1-1.76-2.98A10 10 0 0 1 2 13q0-2.07.79-3.9A10 10 0 0 1 8.1 3.79 10 10 0 0 1 12 3q2.07 0 3.9.79a10 10 0 0 1 5.31 5.31q.8 1.83.79 3.9a10 10 0 0 1-.64 3.52 10 10 0 0 1-1.76 2.98 1 1 0 0 1-.69.34 1 1 0 0 1-.71-.29 1 1 0 0 1-.27-.7q0-.42.27-.75A8 8 0 0 0 20 13q0-3.35-2.32-5.67A7.7 7.7 0 0 0 12 5Q8.66 5 6.33 7.33A7.7 7.7 0 0 0 4 13a8 8 0 0 0 1.83 5.07q.27.33.28.74.02.42-.29.71m2.82-2.82q-.3.3-.73.31-.42.02-.67-.34a7 7 0 0 1-.91-1.7A6 6 0 0 1 6 13q0-2.5 1.75-4.25A5.8 5.8 0 0 1 12 7q2.5 0 4.25 1.75A5.8 5.8 0 0 1 18 13a5.8 5.8 0 0 1-1.25 3.68.8.8 0 0 1-.68.33 1 1 0 0 1-.72-.29 1 1 0 0 1-.29-.7q0-.42.24-.77.33-.5.51-1.06.2-.57.19-1.19 0-1.65-1.18-2.82A4 4 0 0 0 12 9q-1.65 0-2.82 1.18A4 4 0 0 0 8 13q0 .64.19 1.2t.51 1.05q.25.35.24.76t-.29.69m1.94-2.29q-.6-.59-.59-1.41 0-.83.59-1.41.59-.6 1.41-.59.83 0 1.41.59.6.59.59 1.41 0 .83-.59 1.41-.59.6-1.41.59-.83 0-1.41-.59" />
  </svg>
)
export default SvgSignals
